import { computed } from 'vue';
import useSession from '@/hooks/session';
import useAuth from '@/hooks/auth';

export default function useFilter() {
  const { sessionNameIds } = useSession();
  const { user } = useAuth();

  const sessionNameIdsFilteredByRole = computed(() => sessionNameIds.value.filter(
    (session) => {
      let result = [];
      if (user.value.roles.includes('R&D')
        || user.value.roles.includes('HRL')
        || user.value.roles.includes('OTHER-STAFF')
      ) {
        result = session;
      } else if (user.value.roles.includes('K12-STUDENT')) {
        result = session.sessionType.includes('K-12');
      } else if (user.value.roles.includes('STUDENT')) {
        result = session.sessionType.includes('Academic')
          || session.sessionType.includes('EAP')
          || session.sessionType.includes('Summer')
          || session.sessionType.includes('OIP');
      }

      return result;
    },
  ));

  return {
    sessionNameIdsFilteredByRole,
  };
}
